import i18next from "i18next";
import React from "react";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { Link, useNavigate } from "react-router-dom";
import { useStores } from "_common/hooks";
import { observer } from "mobx-react-lite";

const KYC = observer(() => {
  const navigate = useNavigate();
  const {
    authStore: { user },
  } = useStores();

  return (
    <div className="container !mt-[70px]">
      <HeaderTop
        title={i18next.t("kyc_title")}
        onBack={() => navigate("/member")}
      />
      <div className="flex flex-col gap-6 p-4">
        <div className="p-4 bg-[#1c1c1e] rounded">
          <h2 className="text-xl text-white pb-8 border-b border-[#ffffff1a] flex items-center justify-between">
            Lv.1
            {user?.level >= 1 && (
              <div className="flex items-center gap-2">
                <svg
                  className="MuiSvgIcon-root MuiSvgIcon-colorSuccess MuiSvgIcon-fontSizeMedium css-nm8jzx"
                  width="25"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#00b42a"
                >
                  <path
                    fillRule="evenodd"
                    d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M10 17H5v-2h5zm0-4H5v-2h5zm0-4H5V7h5zm4.82 6L12 12.16l1.41-1.41 1.41 1.42L17.99 9l1.42 1.42z"
                  />
                </svg>
                <span className="mb-[2px] text-[16px] font-normal text-[#00b42a]">
                  {i18next.t("note6")}
                </span>
              </div>
            )}
          </h2>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <span className="text-[14px] text-white">
                {i18next.t("note6")}
              </span>
              <div className="flex justify-between">
                <span className="text-[14px] text-[#888]">
                  {i18next.t("note8")}
                </span>
                <span className="text-[14px] text-white">
                  {i18next.t("note9")}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-[14px] text-[#888]">
                  {i18next.t("withdraw_amount")}
                </span>
                <span className="text-[14px] text-white">
                  {i18next.t("note9")}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-[14px] text-[#888]">
                  {i18next.t("other")}
                </span>
                <span className="text-[14px] text-white">
                  {i18next.t("note10")}
                </span>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex items-center gap-2 text-[15px] text-white">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 24 24"
                  height="20px"
                  width="20px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9.715 12c1.151 0 2-.849 2-2s-.849-2-2-2-2 .849-2 2 .848 2 2 2z" />
                  <path d="M20 4H4c-1.103 0-2 .841-2 1.875v12.25C2 19.159 2.897 20 4 20h16c1.103 0 2-.841 2-1.875V5.875C22 4.841 21.103 4 20 4zm0 14-16-.011V6l16 .011V18z" />
                  <path
                    stroke="#3D5AFE"
                    fill="#3D5AFE"
                    d="M14 9h4v2h-4zm1 4h3v2h-3zm-1.57 2.536c0-1.374-1.676-2.786-3.715-2.786S6 14.162 6 15.536V16h7.43v-.464z"
                  />
                </svg>
                <span>{i18next.t("note11")}</span>
              </div>
              <div className="flex items-center gap-2 text-[15px] text-white">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 16 16"
                  height="20px"
                  width="20px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
                  <path
                    stroke="#3D5AFE"
                    fill="#3D5AFE"
                    d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                  />
                </svg>
                <span>{i18next.t("note12")}</span>
              </div>
            </div>
            {!user?.level && (
              <Link
                to="/member/kyc/step1"
                type="button"
                className="py-[12px] mt-2 px-4 bg-[#3d5afe] disabled:hover:bg-[#3d5afe] disabled:opacity-50 hover:bg-[#2a3db0] rounded text-center text-white text-[14px] font-medium"
              >
                {i18next.t("note13")}
              </Link>
            )}
          </div>
        </div>
        <div className="p-4 bg-[#1c1c1e] rounded">
          <h2 className="text-xl text-white pb-8 border-b border-[#ffffff1a] flex items-center justify-between">
            Lv.2
            <div className="flex items-center gap-2" />
          </h2>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <span className="text-[14px] text-white">
                {i18next.t("note7")}
              </span>
              <div className="flex justify-between">
                <span className="text-[14px] text-[#888]">
                  {i18next.t("note8")}
                </span>
                <span className="text-[14px] text-white">
                  {i18next.t("note9")}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-[14px] text-[#888]">
                  {i18next.t("withdraw_amount")}
                </span>
                <span className="text-[14px] text-white">
                  {i18next.t("note9")}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-[14px] text-[#888]">
                  {i18next.t("other")}
                </span>
                <span className="text-[14px] text-white">
                  {i18next.t("note14")}
                </span>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex items-center gap-2 text-[15px] text-white">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z"
                  />
                  <path
                    fill="#3D5AFE"
                    fillRule="evenodd"
                    d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"
                  />
                </svg>
                <span>{i18next.t("note15")}</span>
              </div>
            </div>
            {!user?.level && (
              <button
                disabled
                type="button"
                className="py-[12px] mt-2 px-4 disabled:bg-[#343338] bg-[#3d5afe] disabled:hover:bg-[#343338] disabled:opacity-50 hover:bg-[#2a3db0] rounded text-center text-white text-[14px] font-medium"
              >
                {i18next.t("note16")}
              </button>
            )}
            {user?.level === 1 && (
              <Link
                to="/member/kyc/step3"
                type="button"
                className="py-[12px] mt-2 px-4 disabled:bg-[#343338] bg-[#3d5afe] disabled:hover:bg-[#343338] disabled:opacity-50 hover:bg-[#2a3db0] rounded text-center text-white text-[14px] font-medium"
              >
                {i18next.t("note13")}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default KYC;
